import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function AuthCallback() {
  const nav = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => nav('/', { replace: true }), 250);
    return () => clearTimeout(t);
  }, [nav]);
  return (
    <div className="card p-8 text-center">
      <div className="h-6 w-6 mx-auto mb-3 border-2 border-accent border-t-transparent rounded-full animate-spin" />
      <p className="text-mute">Signing you in…</p>
    </div>
  );
}
